import React from 'react';
import Typography from '../../../../../../components/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import titleStyles from './styles/titleStyles';

const Title = ({ classes }) => (
  <Typography className={classes.root} component="h2">
    Low-cost, secure, reliable,{' '}
    <span className={classes.bold}>Tablet Gaming</span> without remote servers
  </Typography>
);

export default withStyles(titleStyles)(Title);
